import {
  createBetweenMediaSelector,
  createMaxMediaSelector,
  createMinMediaSelector,
} from "./utils";

export const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  desktop: "2560px",
};

export const theme = {
  colors: {
    black_primaryText: "#000000",
    gray01_secondaryText: "#4E4E4E",
    gray02_border: "#4E4E4E",
    gray03_border2: "#D9D9D9",
    gray04_background: "#DFDFDF",
    gray05_input: "#F2F2F2",
    white: "#FFFFFF",
    blue01_active: "#0100C6",
    blue02_hover: "#0201AB",
    blue03_discabled: "#9999E8",
    red01_alert: "#FF0040",
    red02_hover: "#CA0033",
    red03_disabled: "#FFE6EC",
    green01_success: "#00D455",
    green02_hover: "#00B548",
    green02_disabled: "#EFFDF5",
  },
  fontSize: {
    small: "12px",
    normal: "16px",
    big: "20px",
  },
  fontWeight: {
    small: "400",
    normal: "500",
    big: "700",
  },
  buttonSize: {
    projFormH: "48px",
  },
  sizes: {
    icon: "25",
  },
  device: {
    mobileS: `(min-width: ${size.mobileS})`,
    mobileM: `(min-width: ${size.mobileM})`,
    mobileL: `(min-width: ${size.mobileL})`,
    MmobileL: `(max-width: ${size.mobileL})`,
    tablet: `(min-width: ${size.tablet})`,
    Mtablet: `(max-width: ${size.tablet})`,
    Mlaptop: `(max-width: ${size.laptop})`,
    laptop: `(min-width: ${size.laptop})`,
    laptopL: `(min-width: ${size.laptopL})`,
    desktop: `(min-width: ${size.desktop})`,
    desktopL: `(min-width: ${size.desktop})`,
  },
  radius: {
    //mainRadius: "30px",
    //secondaryRadius: "15px",
    thirdRadius: "8px",
  },
  fonts: {
    interBold: "Inter Bold",
    interRegular: "Inter Regular",
    interMedium: "Inter medium",
  },
  width: {
    desktopMaxWidthForm: "60rem",
  },
  maxView: {
    menuBar: "1500px",
  },
};

export const breakpoints = {
  mobileMini: 260,
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptop: 1024,
  laptopHelper: 1280,
  laptopL: 1440,
  desktop: 2560,
};
export type BreakpointName = keyof typeof breakpoints;

export const media = {
  between(
    minBreakpoint: BreakpointName,
    maxBreakpoint: BreakpointName
  ): string {
    const minWidth = breakpoints[minBreakpoint];
    const maxWidth = breakpoints[maxBreakpoint];
    return `@media all and ${createBetweenMediaSelector(minWidth, maxWidth)}`;
  },

  max(breakpoint: BreakpointName): string {
    const maxWidth = breakpoints[breakpoint];
    return `@media all and ${createMaxMediaSelector(maxWidth)}`;
  },

  min(breakpoint: BreakpointName): string {
    const minWidth = breakpoints[breakpoint];
    return `@media all and ${createMinMediaSelector(minWidth)}`;
  },

  matches: {
    between(
      minBreakpoint: BreakpointName,
      maxBreakpoint: BreakpointName
    ): boolean {
      const minWidth = breakpoints[minBreakpoint];
      const maxWidth = breakpoints[maxBreakpoint];

      return window.matchMedia(createBetweenMediaSelector(minWidth, maxWidth))
        .matches;
    },

    max(breakpoint: BreakpointName): boolean {
      const maxWidth = breakpoints[breakpoint];
      return window.matchMedia(createMaxMediaSelector(maxWidth)).matches;
    },

    min(breakpoint: BreakpointName): boolean {
      const minWidth = breakpoints[breakpoint];
      return window.matchMedia(createMinMediaSelector(minWidth)).matches;
    },
  },

  onChange: {
    between(
      minBreakpoint: BreakpointName,
      maxBreakpoint: BreakpointName,
      callback: (evt: MediaQueryListEvent) => void
    ): () => void {
      const minWidth = breakpoints[minBreakpoint];
      const maxWidth = breakpoints[maxBreakpoint];
      const mediaQuery = createBetweenMediaSelector(minWidth, maxWidth);

      window.matchMedia(mediaQuery).addListener(callback);

      return () => {
        window.matchMedia(mediaQuery).removeListener(callback);
      };
    },

    max(
      breakpoint: BreakpointName,
      callback: (evt: MediaQueryListEvent) => void
    ): () => void {
      const maxWidth = breakpoints[breakpoint];
      const mediaQuery = createMaxMediaSelector(maxWidth);

      window.matchMedia(mediaQuery).addListener(callback);

      return () => {
        window.matchMedia(mediaQuery).removeListener(callback);
      };
    },

    min(
      breakpoint: BreakpointName,
      callback: (evt: MediaQueryListEvent) => void
    ): () => void {
      const minWidth = breakpoints[breakpoint];
      const mediaQuery = createMinMediaSelector(minWidth);

      window.matchMedia(mediaQuery).addListener(callback);

      return () => {
        window.matchMedia(mediaQuery).removeListener(callback);
      };
    },
  },
};
